export default __webpack_public_path__ + "static/media/0487_IMG8141.7af3f0fa.jpg";